module.exports = __webpack_public_path__ + "static/media/pet_lvl3.1db69793.png";